exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/payment-statements/payment-statements.component.css
// module id = ../../../../../src/app/payment-statements/payment-statements.component.css
// module chunks = main